const defaultSizing = null;
const mapSizes = (s) => s.map(m=> { console.log(m); return { size: m[0], description: m[1] } });
const sizeOptions = [
    {
        category: "T-SHIRTS",
        sizes: mapSizes([
            ["12-18m","31-33\" tall, 23-26 lbs"],
            ["2T", "33-36\" tall, 26-31 lbs"],
            ["3/4T", "36-42\" tall, 31-39 lbs"],
            ["5/6Y", "42-48\" tall, 39-50 lbs"]
        ])
    },
    {
        category: "JOGGERS",
        sizes: mapSizes([
            ["Adult XXS/XS","size 0-2"],
            ["Adult XS","size 0-2"],
            ["Adult Small", "size 4-6"],
            ["Adult Medium", "size 8-10"],
            ["Adult Large", "size 12-14"],
            ["Adult Large/XL", "size 14-16"],
            ["Adult XL/2XL", "size 16-22"],
            ["Adult 2XL/3XL", "size 18-24"]
        ])
    }
];
